import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailAccountsStore"*/ './lazyIndex')
);

export const lazyAddAccount = new LazyAction(lazyModule, m => m.addAccount);
export const lazyRemoveAccountByEmail = new LazyAction(lazyModule, m => m.removeAccountByEmail);
export const lazyRemoveAccountById = new LazyAction(lazyModule, m => m.removeAccountById);
export const lazySetSelectedAccount = new LazyAction(lazyModule, m => m.setSelectedAccount);

export { default as Account } from './store/schema/Account';
export { default as Provider } from './store/schema/Provider';
export { AccountType } from './store/schema/AccountType';
export { default as getProfileStore } from './store/profileStore';
export { getAccountIdByEmailAddress, getAccountEmailAddressById } from './utils/utils';
